<form [formGroup]="instructorBasicForm">
  <div class="row pt-lg-3">
    <div class="col-12 col-md-12 col-lg-4 col-xl-3 profile-photo-upload">
      <div class="form-row">
        <div class="col-md-12">
          <div class="input-item-edit">
            <div class="profile-image profile-image-wrapper">
              <div class="overlay" [ngClass]="{'error': ((instructorBasicForm.invalid && instructorBasicForm.touched) && (!profileImage && !instructorMedia)) || (instructorBasicForm.valid && (!profileImage && !instructorMedia)) }"></div>
              <img *ngIf="!profileImage && !instructorMedia" class="profile-image-circle" src="assets/images/user.png"
                alt="">
              <img *ngIf="!profileImage && instructorMedia" class="profile-image-circle"
                src="{{instructorMedia?.url}}?w=200&h=200&auto=compress&fit=crop&crop=faces" alt="">
              <img *ngIf="profileImage" class="profile-image-circle" [ngfSrc]="profileImage" alt="Profile Image">
              <span ngfSelect
                    [(file)]="profileImage"
                    (filesChange)="fileUploadChange()"
                    [ngClass]="{ 'readonly': isTabReadOnly }"
                    accept="image/*"
                    class="image-edit-button">
                <i class="icon-edit"></i>

              </span>
              <span class="image-required-icon">*</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-12 col-lg-8 col-xl-9">
      <ng-container *ngIf="instructorId">
        <p class="section-info note d-none d-lg-block d-md-block d-xl-block" >
          <ng-container [ngSwitch]="instructorStatus">
          <div *ngSwitchCase="instructorStatusType.APPROVED">
            {{ translationScope+'.instructions.basic_info_form.successful_application_info_initial' | transloco }}
            <br/><br/>
            {{ translationScope+'.instructions.basic_info_form.successful_application_info_middle_1' | transloco }}
            <a [href]="adminWebUrl" target="_blank">{{ translationScope+'.instructions.basic_info_form.admin_web' | transloco
              }}</a>
            {{ translationScope+'.instructions.basic_info_form.successful_application_info_middle_2' | transloco }}
            <a href="mailto:hello@rssjoliv.no" target="_top"> hello@rssjoliv.no</a>.
            <br/>
            {{ translationScope+'.instructions.basic_info_form.successful_application_info_last' | transloco }}
            <br/><br/>
            {{translationScope+'.instructions.basic_info_form.contact_instruction' | transloco}}
            <a href="mailto:hello@rssjoliv.no" target="_top"
            >hello@rssjoliv.no</a>
          </div>
          <div *ngSwitchCase="instructorStatusType.REJECTED">
            {{ translationScope+'.instructions.basic_info_form.basic_application_info_rejected_initial' | transloco }}
            <br/><br/>
            {{translationScope+'.instructions.basic_info_form.contact_customer_center_initial' | transloco}}
            <a href="mailto:hello@rssjoliv.no" target="_top"
            >hello@rssjoliv.no</a>
            {{translationScope+'.instructions.basic_info_form.contact_customer_center_middle_1' | transloco}}
            987 06757
            {{translationScope+'.instructions.basic_info_form.contact_customer_center_middle_2' | transloco}}
          </div>
          <div *ngSwitchCase="instructorStatusType.BLOCKED">
            {{ translationScope+'.instructions.basic_info_form.basic_application_info_rejected_initial' | transloco }}
            <br/><br/>
            {{translationScope+'.instructions.basic_info_form.contact_customer_center_initial' | transloco}}
            <a href="mailto:hello@rssjoliv.no" target="_top"
            >hello@rssjoliv.no</a>
            {{translationScope+'.instructions.basic_info_form.contact_customer_center_middle_1' | transloco}}
            987 06757
            {{translationScope+'.instructions.basic_info_form.contact_customer_center_middle_2' | transloco}}
          </div>
          <div *ngSwitchCase="instructorStatusType.RETURNED">
            {{ translationScope+'.instructions.basic_info_form.basic_application_info_returned_initial' | transloco }}
            <br/>
            {{ translationScope+'.instructions.basic_info_form.basic_application_info_returned_middle_1' | transloco }}
            <br/><br/>
            {{translationScope+'.instructions.basic_info_form.contact_customer_center_initial' | transloco}}
            <a href="mailto:hello@rssjoliv.no" target="_top"
            >hello@rssjoliv.no</a>
            {{translationScope+'.instructions.basic_info_form.contact_customer_center_middle_1' | transloco}}
            987 06757
            {{translationScope+'.instructions.basic_info_form.contact_customer_center_middle_2' | transloco}}
          </div>
          <div *ngSwitchCase="instructorStatusType.NOT_YET_APPROVED">
            {{ translationScope+'.instructions.basic_info_form.basic_application_info_returned_initial' | transloco }}
            <br/>
            {{ translationScope+'.instructions.basic_info_form.basic_application_info_returned_middle_1' | transloco }}
            <br/><br/>
            {{translationScope+'.instructions.basic_info_form.contact_customer_center_initial' | transloco}}
            <a href="mailto:hello@rssjoliv.no" target="_top"
            >hello@rssjoliv.no</a>
            {{translationScope+'.instructions.basic_info_form.contact_customer_center_middle_1' | transloco}}
            987 06757
            {{translationScope+'.instructions.basic_info_form.contact_customer_center_middle_2' | transloco}}
          </div>
          <div *ngSwitchDefault>
            <b> {{translationScope+'.instructions.basic_info_form.basic_info_instruction' | transloco}} </b>
            <br /><br />
            {{translationScope+'.instructions.basic_info_form.basic_info_form_fill_up_instruction_initial' | transloco}}
            <br /><br />
            <b>NB!</b>
            {{translationScope+'.instructions.basic_info_form.basic_info_form_fill_up_instruction_middle' | transloco}}
            <br/><br />
            {{translationScope+'.instructions.basic_info_form.basic_info_form_fill_up_instruction_last' | transloco}}
          </div>
          </ng-container>
        </p>
      </ng-container>
      <div class="form-row">
        <div class="col-12 col-md-6">
          <div class="input-item-edit required">
            <label class="text-uppercase" for="firstName">{{translationScope+'.form.first_name.label' | transloco}}
            </label>
            <div class="row">
              <div class="col-12 col-md-12">
                <input type="text" formControlName="firstName"
                  [class.form-control-error]="isInvalidateControl('firstName', 'required')"
                  class="form-control rounded-0" [placeholder]="translationScope+'.form.first_name.placeholder' | transloco" required />
                <span *ngIf="isInvalidateControl('firstName', 'required')" class="form-control-error-message">
                 {{translationScope+'.form.first_name.error.required' | transloco}}
                </span>

              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="input-item-edit required">
            <label class="text-uppercase" for="lastName">{{translationScope+'.form.last_name.label' | transloco}}
            </label>
            <div class="row">
              <div class="col-12 col-md-12">
                <input type="text" formControlName="lastName"
                  [class.form-control-error]="isInvalidateControl('lastName', 'required')"
                  class="form-control rounded-0" [placeholder]="translationScope+'.form.last_name.placeholder' | transloco" required />
                <span *ngIf="isInvalidateControl('lastName', 'required')" class="form-control-error-message">
                  {{translationScope+'.form.last_name.error.required' | transloco}}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="input-item-edit required">
            <label class="text-uppercase" for="email"> {{translationScope+'.form.email.label' | transloco}} </label>
            <div class="row">
              <div class="col-12 col-md-12">
                <input type="text" formControlName="email"
                  [class.form-control-error]="isInvalidateControl('email', 'required') || instructorBasicForm.get('isInvalidEmail').value"
                  class="form-control rounded-0"
                  [placeholder]="translationScope+'.form.email.placeholder' | transloco" required
                  (blur)="validateEmail()"
                />
                <span *ngIf="isInvalidateControl('email', 'required')" class="form-control-error-message">
                  {{translationScope+'.form.email.error.required' | transloco}}
                </span>
                <div class="text-danger"
                     *ngIf="instructorBasicForm.get('isInvalidEmail').value &&
                            instructorBasicForm.get('email').value"
                > {{ emailSuggestion ?? translationScope + '.form.email.error.invalid' | transloco }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="input-item-edit required">
            <label class="text-uppercase" for="confirmEmail"> {{translationScope+'.form.confirmEmail.label' | transloco}} </label>
            <div class="row">
              <div class="col-12 col-md-12">
                <input type="text" formControlName="confirmEmail"
                  [class.form-control-error]="isInvalidateControl('confirmEmail','required') || isInvalidateControl('confirmEmail','confirmEmail')"
                  class="form-control rounded-0" [placeholder]="translationScope+'.form.confirmEmail.placeholder' | transloco" required />
                <span *ngIf="instructorBasicForm.get('confirmEmail').dirty && isInvalidateControl('confirmEmail','confirmEmail')" class="form-control-error-message">
                  {{translationScope+'.form.confirmEmail.error.confirmEmail' | transloco}}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="input-item-edit required">
            <label class="text-uppercase" for="phone-number" >{{translationScope+'.form.phone_number.label' | transloco}}
            </label>
            <div class="row">
              <div class="col-12 col-md-12">
                  <div class="d-flex align-items-center country-phone-wrapper">
                    <div class="input-group">
                      <ng-select class="input-group-prepend phone-code"
                                 [class.phonePrefix-error]="instructorBasicForm.get('phone').touched && instructorBasicForm.get('phone').errors"
                                 [searchable]="false"
                                 formControlName="phonePrefix"
                                 [clearable]="false">
                        <ng-option *ngFor="let country of countryList$ | async"
                                   [value]="country.phonePrefix">
                          {{country.twoLetterISOCode + '(' + country.phonePrefix + ')'}}
                        </ng-option>
                      </ng-select>
                      <input
                        [class.form-control-error]="instructorBasicForm.get('phone').touched && instructorBasicForm.get('phone').errors"
                        type="text"
                        id="phone-number"
                        formControlName="phone"
                        class="form-control rounded-0"
                        placeholder="{{ translationScope+'.form.phone_number.placeholder' | transloco }}"
                        required
                      />
                    </div>
                  </div>
                  <span *ngIf="instructorBasicForm.get('phone').value?.length === 0" class="form-control-error-message">
                    {{ translationScope + '.form.phone_number.error.required' | transloco }}
                  </span>
                  <span *ngIf="instructorBasicForm.get('phone').touched && instructorBasicForm.get('phone').errors && instructorBasicForm.get('phone').value?.length"
                        class="form-control-error-message">{{ translationScope + '.form.phone_number.error.invalid' | transloco }}
                  </span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-md-6">
          <div class="input-item-edit required">
            <label class="text-uppercase" for="birthDate" >{{translationScope+'.form.date_of_birth.label' | transloco}}
            </label>
            <div class="row">
              <div class="col-12 col-md-12" *ngIf="isBrowser">
                <input id="birthDate" type="text" [matDatepicker]="birthdatePicker" [max]="birthDatePickerConfig.max" [min]="birthDatePickerConfig.min" (click)="openBirthdatePicker()" formControlName="birthDate"
                       [class.form-control-error]="isInvalidateControl('birthDate', 'required')"
                       readonly
                       class="form-control rounded-0" [placeholder]="translationScope+'.form.date_of_birth.placeholder' | transloco" required />
                <mat-datepicker #birthdatePicker startView="multi-year" [restoreFocus]="true" [startAt]="birthDatePickerConfig.startAt" disabled="false"></mat-datepicker>
                <span *ngIf="isInvalidateControl('birthDate', 'required')" class="form-control-error-message" >{{translationScope+'.form.date_of_birth.error.required' | transloco}}</span>
              </div>
            </div>
          </div>
        </div>
         <div class="col-12">
           <p class="paragraph">
            {{translationScope+'.instructions.basic_info_form.instructor_contact_visibility' | transloco}}
           </p>
         </div>
        <div class="col-12 my-3">
          <h3>{{translationScope+'.titles.company_information' | transloco}}</h3>
          <p>{{translationScope+'.titles.basic_information' | transloco}}</p>
        </div>

        <div class="col-md-12">
          <div class="input-item-edit required">
            <label class="text-uppercase" for="organizationName"> {{translationScope+'.form.organization_name.label' | transloco}} </label>
            <div class="row">
              <div class="col-12 col-md-12">
                <input type="text" formControlName="organizationName"
                  [class.form-control-error]="isInvalidateControl('organizationName', 'required')"
                  class="form-control rounded-0"
                  [placeholder]="translationScope+'.form.organization_name.placeholder' | transloco" required />
                <span *ngIf="isInvalidateControl('organizationName', 'required')" class="form-control-error-message">{{translationScope+'.form.organization_name.error.required' | transloco}}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-12">
          <div class="input-item-edit required">
            <label class="text-uppercase" for="organizationNo"> {{translationScope+'.form.organization_number.label' | transloco}} </label>
            <div class="row">
              <div class="col-12 col-md-12">
                <input type="text" formControlName="organizationNo"
                  [class.form-control-error]="isInvalidateControl('organizationNo', 'required')"
                  class="form-control rounded-0" [placeholder]="translationScope+'.form.organization_number.placeholder' | transloco" required />
                <span *ngIf="isInvalidateControl('organizationNo', 'minlength') || isInvalidateControl('organizationNo', 'maxlength') || isInvalidateControl('organizationNo', 'pattern')" class="form-control-error-message">{{translationScope+'.form.organization_number.error.invalid' | transloco}}</span>
                <span *ngIf="isInvalidateControl('organizationNo', 'required')" class="form-control-error-message">{{translationScope+'.form.organization_number.error.required' | transloco}}</span>
              </div>
            </div>
          </div>
        </div>

        <ng-container formGroupName="address">
          <!-- Address Input -->
          <div class="col-md-12">
            <div class="input-item-edit required">
              <label class="text-uppercase" for="streetAddress">{{translationScope+'.form.address.label' | transloco}}</label>
              <div class="row">
                <div class="col-12 col-md-12">
                  <input type="text" formControlName="streetAddress"
                    [class.form-control-error]="isInvalidateControl('address.streetAddress', 'required')"
                    class="form-control rounded-0" [placeholder]="translationScope+'.form.address.placeholder' | transloco" required />
                  <span *ngIf="isInvalidateControl('address.streetAddress', 'required')" class="form-control-error-message">{{translationScope+'.form.address.error.required' | transloco}}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6">
            <div class="input-item-edit required">
              <label class="text-uppercase" for="postalCode">{{translationScope+'.form.postal_code.label' | transloco}} </label>
              <div class="row">
                <div class="col-12 col-md-12">
                  <input type="text" formControlName="postalCode"
                    [class.form-control-error]="isInvalidateControl('address.postalCode', 'required')"
                    class="form-control rounded-0"
                    [placeholder]="translationScope+'.form.postal_code.placeholder' | transloco" required />
                  <span *ngIf="isInvalidateControl('address.postalCode', 'minlength') || isInvalidateControl('address.postalCode', 'maxlength') || isInvalidateControl('address.postalCode', 'pattern')" class="form-control-error-message">{{translationScope+'.form.postal_code.error.invalid' | transloco}}</span>
                  <span *ngIf="isInvalidateControl('address.postalCode', 'required')" class="form-control-error-message">{{translationScope+'.form.postal_code.error.required' | transloco}}</span>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12 col-md-6">
            <div class="input-item-edit required">
              <label class="text-uppercase" for="city">{{translationScope+'.form.city.label' | transloco}}</label>
              <div class="row">
                <div class="col-12 col-md-12">
                  <input type="text" formControlName="city"
                    [class.form-control-error]="isInvalidateControl('address.city', 'required')"
                    class="form-control rounded-0" [placeholder]="translationScope+'.form.city.placeholder' | transloco" required />
                  <span *ngIf="isInvalidateControl('address.city', 'required')" class="form-control-error-message">{{translationScope+'.form.city.error.required' | transloco}}</span>
                </div>
              </div>
            </div>
          </div>

          <!--<div class="col-12 col-md-6">
            <div class="input-item-edit required">
              <label class="text-uppercase" for="region">Region </label>
              <div class="row">
                <div class="col-12 col-md-12">
                  <input type="text" formControlName="region"
                    [class.form-control-error]="isInvalidateControl('address.region', 'required')"
                    class="form-control rounded-0" placeholder="Region" required />
                  <span *ngIf="isInvalidateControl('address.region', 'required')" class="form-control-error-message">Region er påkrevd</span>
                </div>
              </div>
            </div>
          </div>-->

          <div class="col-12 col-md-12">
            <div class="input-item-edit required">
              <label class="text-uppercase" for="country-of-residence" >{{translationScope+'.form.country.label' | transloco}}</label>
              <div class="row">
                <div class="col-12 col-md-12">
                  <ng-select [items]="country$ | async" bindValue="twoLetterISOCode" bindLabel="name"
                    [placeholder]="translationScope+'.form.country.placeholder' | transloco"  id="country-of-residence" formControlName="country"
                    [typeahead]="countryTypehead$">
                  </ng-select>
                  <span *ngIf="isInvalidateControl('address.country', 'required')"
                    class="form-control-error-message" >{{translationScope+'.form.country.error.required' | transloco}}</span>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

      </div>

      <div class="form-row">
        <div class="col-12 col-md-12">
          <div class="input-item-edit required">
            <label for="instructor-region" class="text-uppercase">{{translationScope+'.form.region.label' | transloco}} </label>
            <div class="row">
              <div class="col-12 col-md-12" *ngIf="isBrowser">
                <ng-select
                  [items]="regions$ | async"
                  [multiple]="true"
                  [closeOnSelect]="false"
                  [hideSelected]="true"
                  [compareWith]="mapSelectedRegionId"
                  bindLabel="name"
                  [placeholder]="translationScope+'.form.region.placeholder' | transloco"
                  id="instructor-region"
                  formControlName="regions">
                </ng-select>
                <span *ngIf="isInvalidateControl('regions', 'required')" class="form-control-error-message">
                  {{translationScope+'.form.region.error.required' | transloco}}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

        <!-- Description -->
        <div class="form-row">
          <div class="col-md-12">
            <div class="input-item-edit required">
              <label for="type-experience" class="text-uppercase" > {{translationScope+'.form.description.label' | transloco}}
              </label>
              <div class="row">
                <div class="col-12 col-md-12">
                  <textarea type="text" #description formControlName="description" class="form-control form-control-textarea rounded-0"
                    [class.form-control-error]="isInvalidateControl('description', 'required')"
                    rows="10" cols="50"
                    [placeholder]="translationScope+'.form.description.placeholder' | transloco"  required>
                  </textarea>
                  <!--<input type="text" formControlName="description" class="form-control rounded-0"
                    [class.form-control-error]="isInvalidateControl('description', 'required')"
                    placeholder="1000-1500 characters minimum" required /> -->
                  <!-- <span class="float-right">{{description.value?.length}}</span> -->
                  <span *ngIf="isInvalidateControl('description', 'required')"
                    class="form-control-error-message" > {{translationScope+'.form.description.error.required' | transloco}}</span>
                  <!-- <span *ngIf="isInvalidateControl('description', 'minlength')" class="form-control-error-message">Description must be at least 1000-1500 characters</span> -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row btn-control-group">
          <div class="col-6">
            <button *ngIf="isDraft" (click)="submitDraftInstructorBasicForm()"  class="btn btn-success form-control rounded-0" >
              {{translationScope+'.action_buttons.save_for_later' | transloco}}
            </button>
          </div>
          <div  [ngClass] = "isDraft ? 'col-6' : 'col-12'">
            <button (click)="submitInstructorBasicForm()" *ngIf="!isUpdate" class="btn btn-success form-control rounded-0" >
              {{translationScope+'.action_buttons.next' | transloco}}
            </button>
            <button *ngIf="isUpdate && !isTabReadOnly" (click)="submitInstructorBasicForm()" class="btn btn-success form-control rounded-0" >
              {{translationScope+'.action_buttons.update' | transloco}}
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 col-12 col-lg-12 note" style="margin-top: 15px">
          <span >
           {{translationScope+'.instructions.basic_info_form.data_collection_info_text' | transloco}}
          </span>
          <span *ngIf="((instructorBasicForm.invalid && instructorBasicForm.touched) || (!profileImage && !instructorMedia)) || (instructorBasicForm.valid && (!profileImage && !instructorMedia))" class="text-danger" >
           *{{translationScope+'.instructions.basic_info_form.form_invalid' | transloco}}
          </span>
        </div>
      </div>
  </div>
</form>
